/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

interface CorsErrorModalProps {
  open: boolean;
  onClose: () => void;
  okta_issuer: string;
}

function CorsErrorModal({ open, onClose, okta_issuer }: CorsErrorModalProps) {
  // Build URL to "Trusted Origins" page in admin panel
  const baseUrl = okta_issuer.split('/oauth2')[0] || '';
  const hostParts = new URL(baseUrl).host.split('.');
  hostParts[0] += '-admin';
  const adminHost = hostParts.join('.');
  const corsAdminUrl = `https://${adminHost}/admin/access/api/trusted_origins`;
  const guideUrl = 'https://developer.okta.com/docs/guide/enable-cors/granting-cors/';

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Network Error
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <p>Seems like logout API call resulted with CORS error.</p>
          <p>
            You may need to add your origin {window.location.origin} to the list of trusted origins in your{' '}
            <a href={corsAdminUrl} target="_blank" rel="noreferrer">
              Okta Administrator Dashboard
            </a>
          </p>
          <p>
            Read{' '}
            <a href={guideUrl} target="_blank" rel="noreferrer">
              this guide
            </a>{' '}
            for more info.
          </p>
        </Typography>
      </Box>
    </Modal>
  );
}

export default CorsErrorModal;
